export type FormTypes = {
  bulletin: string
  gate: string
  insurtech: string
}

const formTypes: FormTypes = Object.freeze({
  bulletin: 'bulletin',
  gate: 'gate',
  insurtech: 'insurtech',
  paperDetail: 'paperDetail'
})

export default formTypes
